import { useAuth0 } from '@auth0/auth0-react';
import { useMutation, useQueryClient } from 'react-query';
import setToken from '../../utils/api';
import { AI_CONVERSATIONS_KEY } from './useAiConversations';
import { AI_CONVERSATION_KEY } from './useAiConversation';

export default function useDeleteAiConversation() {
  const queryClient = useQueryClient();
  const { getAccessTokenSilently } = useAuth0();
  return useMutation<void, Error, { id: number }>(
    ['delete-ai-conversation'],
    async ({ id }) => {
      const token = await getAccessTokenSilently();
      const api = await setToken(token);
      const response = await api.delete<{ message?: string; Message?: string }>(
        `api/ai/conversations/${id}`,
      );
      if (response.status < 200 || response.status >= 300) {
        throw new Error(
          response.data?.message ?? 'Could not delete the conversation',
        );
      }
    },
    {
      onSuccess: (_, { id }) => {
        queryClient.invalidateQueries([AI_CONVERSATIONS_KEY]);
        queryClient.removeQueries([AI_CONVERSATION_KEY, id]);
      },
    },
  );
}
